/**
 * Main entry point for the tracking system
 * This file serves as the central export hub for all tracking-related functionality
 *
 * Exports are organized into the following categories:
 * 1. Event definitions and types (from ./events)
 * 2. Type definitions (from ./types)
 * 3. Utility functions (from ./utils)
 * 4. Core tracking instance (from ./tracking)
 *
 * Using named exports for better tree-shaking support, allowing bundlers
 * to eliminate unused tracking functionality from the final bundle
 */

// Event System
// Contains event name constants, type definitions, and type guards for all tracking events
export * from './events';

// Type Definitions
// Contains interfaces and types used throughout the tracking system
export * from './types';

// Utility Functions
// Contains helper functions for tracking operations
export * from './utils';

// Core Tracking Instance
// Exports the main tracking singleton instance that handles all tracking operations
export { tracking } from './tracking';
